import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SpinnerService } from '../shared/services/spinner.service';
import { GameKeys } from '../shared/consts/page-home-data';

@Component({
  selector: 'pbg-game-rules-dialog',
  templateUrl: './game-rules-dialog.component.html',
  styleUrls: ['./game-rules-dialog.component.scss']
})
export class GameRulesDialogComponent implements OnDestroy {
  GameKeys = GameKeys;

  constructor(
    public dialogRef: MatDialogRef<GameRulesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cookieService: CookieService,
    public route: Router,
    public spinnerService: SpinnerService
  ) {}

  ngOnDestroy() {
    this.close();
  }

  close(): void {
    this.dialogRef.close();
  }

  goToGame(route: string) {
    this.cookieService.deleteAll('/host');
    this.cookieService.deleteAll('/');
    this.cookieService.deleteAll();

    setTimeout(() => {
      this.spinnerService.show();
      this.close();
      this.route.navigate([`/${route}`]);
    }, 250);
  }
}
